import { DataTableWrapMode } from './DataTable.types';

/** Порядок режимов от самой плотной строки к самой высокой — в нём идут пункты
 *  меню кнопки туллбара и сегменты меню «Настройки таблицы». */
export const ROW_HEIGHT_MODES: DataTableWrapMode[] = ['nowrap', 'trim', 'wrap'];

/** Подпись сегмента. Ряд однороден: все три — прилагательные к «высоте строк». */
export const ROW_HEIGHT_LABEL: Record<DataTableWrapMode, string> = {
    nowrap: 'Компактная',
    trim: 'Средняя',
    wrap: 'Полная',
};

/** Что происходит с длинным текстом в этом режиме — подпись пункта меню и строка под сегментами. */
export const ROW_HEIGHT_HINT: Record<DataTableWrapMode, string> = {
    nowrap: 'одна строка, хвост текста — по наведению',
    trim: 'не выше пяти строк',
    wrap: 'строка растёт под текст',
};

/** Заголовок кнопки туллбара: состояние читается без открытия чего-либо. */
export const rowHeightTitle = (mode: DataTableWrapMode): string =>
    `Высота строк: ${ROW_HEIGHT_LABEL[mode].toLowerCase()}`;
